(ns frontend.test.lp-portal.modals.chart-editor.style)

(defn chart-container
  []
  (with-meta
    {:max-width "700px"}
    {}))
